export default __webpack_public_path__ + "aa49e3ddf20dcb1cb9df13b875564ded.woff2";